import { clsx } from 'clsx'
import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import { DialogContent, DialogTitle, Modal } from 'base-ui'

import { DrawerTransition } from '../../../../../drawer-transition/'

import { ProductOfferList } from './ProductOfferList'

import styles from './ProductOfferDrawer.module.css'

type ProductOfferDrawerProps = {
  handleClose: () => void
  isOpen: boolean
}

export const ProductOfferDrawer: FC<ProductOfferDrawerProps> = ({
  handleClose,
  isOpen,
}) => (
  <Modal
    className={clsx(
      styles['product-offer-drawer'],
      'flex flex-col items-end justify-end rounded-l-m',
    )}
    closeAfterTransition
    data-qa-id="offerSelectionModal"
    onClose={handleClose}
    open={isOpen}
  >
    <DrawerTransition
      // eslint-disable-next-line tailwindcss/no-arbitrary-value -- don't reference, refactor if touched
      className="mt-[120px] flex h-dvh w-full flex-col overflow-y-auto rounded-t-m bg-light-primary-medium outline-none tablet:mt-0 tablet:max-w-screen-tablet tablet:rounded-l-m tablet:rounded-tr-none"
      in={isOpen}
    >
      <DialogTitle className="bg-light-primary-medium" onClose={handleClose}>
        <FormattedMessage id="productOffer.modal.title" />
      </DialogTitle>
      <DialogContent>
        <ProductOfferList />
      </DialogContent>
    </DrawerTransition>
  </Modal>
)
